module.exports = __webpack_public_path__ + "img/gav.07d355ed.jpg";